import { Box, Tab, Tabs, CircularProgress, css } from '@mui/material';
import { useState, useEffect } from 'react';
import alertify from 'alertifyjs';

import { LayerDashboardTab } from './LayerDashboardTab';
import { SummaryDashboardTab } from './SummaryDashboardTab';
import { LayerDashboardTabProvider } from '../../features/layer-dashboard/context/LayerDashboardContext';
import { useGetLayerGroupDashboardInfo } from 'features/layer-dashboard/api/layerDashboardApi';
import { getLayerDashboardUrlParams } from 'features/layer-dashboard/utils/layoutDashboardUrlUtils';
import { ILayerDashboard } from 'features/layer-dashboard/model/ILayerDashboardMainResponse';

const urlParams = getLayerDashboardUrlParams();

const loading = css({
    background: '#c8c8c8',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

export const LayerGroupDashboard = () => {
    const [tabSelected, setTabSelected] = useState(0);
    const [tabsAlreadyRendered, setTabsAlreadyRendered] = useState<number[]>([0]);

    const { data, isLoading, isError } = useGetLayerGroupDashboardInfo(urlParams.dashboardGroupToken);

    useEffect(() => {
        if (isError) {
            alertify.alert('Um erro ocorreu');
        }
    }, [isError]);

    useEffect(() => {
        if (tabSelected !== 0 && !tabsAlreadyRendered.includes(tabSelected)) {
            setTabsAlreadyRendered(prev => [...prev, tabSelected]);
        }
    }, [tabSelected]);

    return (
        <Box sx={{ width: '100%' }}>
            {isLoading &&
                <Box css={loading}>
                    <CircularProgress></CircularProgress>
                </Box>
            }

            <Box sx={{ borderBottom: 1, borderColor: 'divider', height: 30, minHeight: 30 }}>
                <Tabs value={tabSelected} onChange={(event, newValue) => setTabSelected(newValue)}>
                    <Tab label="Sumário" sx={{ minHeight: 30, height: 30, padding: '0 8px' }} />
                    {data?.DashboardLayers.map((item: ILayerDashboard) => (
                        <Tab label={item.Title} sx={{ minHeight: 30, height: 30, padding: '0 8px' }} />
                    ))}
                </Tabs>
            </Box>

            <LayerDashboardTabProvider tabsAlreadyRendered={tabsAlreadyRendered} display={tabSelected === 0 } index={0}>
                <SummaryDashboardTab data={data} />
            </LayerDashboardTabProvider>

            {data?.DashboardLayers.map((item: ILayerDashboard, index: number) => {
                return (
                    <LayerDashboardTabProvider tabsAlreadyRendered={tabsAlreadyRendered} display={tabSelected === index + 1} index={index + 1}>
                        <LayerDashboardTab data={item} />
                    </LayerDashboardTabProvider>
                );
            })}
        </Box>
    );
};